export const getQueryParams = (state) => {
  const { location } = state.router;
  if (location) {
    return location.query;
  }
  return {};
};

export const getPathname = (state) => {
  const { location } = state.router;
  if (location) {
    return location.pathname;
  }
  return null;
};
